
<template>

<el-tabs v-model="activeName" type="card" @tab-click="handleClick">
    <el-tab-pane label="入驻收费记录" name="first" :lazy="true">
        <join-free ref="clue-management"></join-free>
    </el-tab-pane>
    <el-tab-pane label="分摊账目记录" name="second">
      <free-order-management></free-order-management>
    </el-tab-pane>
</el-tabs>

</template>

<script>

import BasicPager from '@/mixins/BasicPager'
import JoinFree from './JoinFree'
import freeOrderManagement from './freeOrderManagement'
export default {
  name: 'private-tab-index',
  extends: BasicPager,
  data () {
    return {
      isAdmin: false,
      activeName: 'first'
    }
  },
  mounted: function () {
    let userInfo = JSON.parse(localStorage.userInfo)
    this.isAdmin = userInfo.loginPath != 'channel'
    this.$refs['clue-management'].loadList(1)
  },
  components: {
    JoinFree,
    freeOrderManagement
  },
  methods: {
    handleClick (tab, event) {
      let that = this
      switch (tab.index) {
        case '0':
          that.$refs['clue-management'].loadList(1)
          break
        case '1':

          break
        default:
      }

      console.log(tab, event)
    }
  }
}

</script>
